<template>
  <div class="flex items-center flex-wrap">
    <div
      v-for="(color, index) in colors"
      :key="index"
      role="checkbox"
      tabindex="0"
      @click="select(color)"
      :aria-checked="value === color"
      class="color-tag-picker__swatch"
      :style="swatchStyle(color)"
    ></div>

    <label class="color-tag-picker__custom-wrapper" :title="customLabel">
      <input
        type="color"
        :value="value || colors[0]"
        @input="select($event.target.value)"
        class="color-tag-picker__custom"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: 'ColorTagPicker',
  props: {
    value: {
      type: String,
      default: null
    },
    colors: {
      type: Array,
      default: () => [
        '#ffa12f', '#ff5722', '#b60ca0', '#e50950',
        '#6c1a54', '#1E88E5', '#0235cc', '#3f5fd0',
        '#423572', '#08e0ae', '#07a092', '#1db954',
        '#0b6509', '#6d7c21', '#52391c', '#757380'
      ]
    },
    customLabel: {
      type: String,
      default: 'Cor personalizada'
    }
  },
  methods: {
    select(color) {
      this.$emit('input', color);
    },
    swatchStyle(color) {
      return this.value === color ? `background: ${color}; box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.4);` : `background: ${color};`;
    }
  }
};
</script>

<style scoped>
.color-tag-picker__swatch {
  width: 1.625rem;
  height: 1.625rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  display: inline-block;
  border-radius: 9999px;
  border: 3px solid #ffffff;
  cursor: pointer;
  outline: none;
}
.color-tag-picker__swatch:focus {
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
}
.color-tag-picker__custom-wrapper {
  display: inline-flex;
  align-items: center;
  margin-bottom: 0.5rem;
  cursor: pointer;
}
.color-tag-picker__custom {
  width: 1.625rem;
  height: 1.625rem;
  padding: 0;
  border: 2px dashed #cbd5e0;
  border-radius: 9999px;
  background: transparent;
  cursor: pointer;
}
.color-tag-picker__custom::-webkit-color-swatch-wrapper {
  padding: 0;
}
.color-tag-picker__custom::-webkit-color-swatch {
  border: none;
  border-radius: 9999px;
}
.color-tag-picker__custom::-moz-color-swatch {
  border: none;
  border-radius: 9999px;
}
</style>
